/**
 * InviteFormSkeleton Component
 * Feature: 012-care-seeker-invite-signup
 *
 * Skeleton loader displayed while fetching invite or referral data.
 * Green background layout matching the app's signup page style.
 */

import { Skeleton } from '@/shared/components/ui/skeleton';
import SignupBackground from '@/assets/login_background.png';

export const InviteFormSkeleton = () => (
  <div className="bg-[#026857]">
      <main className="bg-[#026857] md:container py-12 flex max-md:flex-col items-center gap-16">
      <section
        className="md:w-2/4 py-12 max-md:container"
        aria-label="Loading invite details"
      >
        <Skeleton className="h-24 w-full rounded-3xl bg-white/15 mb-8" />
        <Skeleton className="h-10 w-3/4 bg-white/15 mb-6" />
        <Skeleton className="h-6 w-full bg-white/15 mb-3" />
        <Skeleton className="h-6 w-2/3 bg-white/15 mb-8" />

        <div className="py-12 gap-6 flex flex-col">
          <div className="flex flex-col gap-3">
            <Skeleton className="h-5 w-24 bg-white/15" />
            <Skeleton className="h-12 w-full rounded-3xl bg-white/15" />
          </div>
          <div className="flex flex-col gap-3">
            <Skeleton className="h-5 w-24 bg-white/15" />
            <Skeleton className="h-12 w-full rounded-3xl bg-white/15" />
          </div>
          <div className="flex flex-col gap-3">
            <Skeleton className="h-5 w-32 bg-white/15" />
            <Skeleton className="h-12 w-full rounded-3xl bg-white/15" />
          </div>
          <Skeleton className="h-12 w-40 rounded-3xl bg-white/15" />
        </div>
      </section>

      <section className="rounded-2xl p-2 max-md:mb-24">
        <img
          src={SignupBackground}
          alt="signup_background"
          className="rounded-2xl bg-cover bg-center w-full flex-1"
        />
      </section>
    </main>
  </div>
);
